<script setup lang="ts">
import { ref, defineProps } from 'vue'

const props = defineProps<{
  min?: number
  max?: number
}>()

const minValue = props.min ?? 0
const maxValue = props.max ?? Infinity

const quantity = ref(minValue)

function increment() {
  if (quantity.value < maxValue) quantity.value++
}

function decrement() {
  if (quantity.value > minValue) quantity.value--
}
</script>

<template>
  <v-container class="pa-4" style="max-width: 400px">
    <v-row dense>
      <v-col cols="12" class="d-flex align-center">
        <div class="d-inline-flex align-center rounded-pill border px-2 py-1">
          <v-btn
            icon
            size="small"
            variant="text"
            :disabled="quantity <= minValue"
            @click="decrement"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>

          <div class="mx-3" style="min-width: 24px; text-align: center">
            {{ quantity }}
          </div>

          <v-btn
            icon
            size="small"
            variant="text"
            :disabled="quantity >= maxValue"
            @click="increment"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
